import { render, staticRenderFns } from "./AddOrUpdateTravel.vue?vue&type=template&id=06c7e131&scoped=true"
import script from "./AddOrUpdateTravel.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateTravel.vue?vue&type=script&lang=js"
import style0 from "./AddOrUpdateTravel.vue?vue&type=style&index=0&id=06c7e131&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c7e131",
  null
  
)

export default component.exports